export default "__VITE_ASSET__SFrFlA$k__"